export const getters = {
  getOrcamento: (state) => state.orcamento,
  getOrcamentos: (state) => state.orcamentos,
  getInfoProposta: (state) => state.infoProposta,
  getModalCadastroOrcamento: (state) => state.modalCadastroOrcamento,
  getModalExcluirOrcamento: (state) => state.modalExcluirOrcamento,
  getItensOrcamento: (state) => state.itensOrcamento,
  getItemOrcamento: (state) => state.itemOrcamento,
  getModalPesquisarProdutosOrcamento: (state) => state.modalPesquisarProdutosOrcamento,
  getModalAdicionarProdutoOrcamento: (state) => state.modalAdicionarProdutoOrcamento,
  getModalImprimirOrcamento: (state) => state.modalImprimirOrcamento,
  getModalEnviarEmailOrcamento: (state) => state.modalEnviarEmailOrcamento,
  getModalInfoProposta: (state) => state.modalInfoProposta,
};

export default {};
